import { apiFetch } from '@ami/react/core';
import { IndustryFilter } from '../industries/industryFilter';
import { Industry } from '../industries/industry';

const _baseEndPoint = 'industries';

export default {
  search: async (filter = new IndustryFilter(), page) => {
    filter.setPaginationParameters(page);
    const result = await apiFetch(
      `${_baseEndPoint}?${filter.toQueryString()}`
    ).then((items) => items.map((x) => new Industry(x)));

    return result;
  },
};
